// marketplaceConfigs.js
export const MARKETPLACE_CONFIGS = {
  amazon: {
    id: 'amazon',
    name: 'Amazon',
    identifierField: 'asin',
    productFilter: (product) => product.asin && product.asin.trim() !== '',
    endpoints: {
      salesRange: '/api/amazon-sales-range',
      updateSales: '/api/update-amazon-sales',
      uploadSales: '/api/upload-amazon-sales',
      uploadStock: '/api/upload-fba-stock',
      stock: '/api/fba-stock',
      awd: '/api/awd-data',
      brands: '/api/yoy-brands',
      niches: '/api/yoy-niches',
      // Monthly
      monthSalesRange: '/api/amazon-month-sales-range',
      updateMonthSales: '/api/update-amazon-month-sales',
      uploadMonthSales: '/api/upload-amazon-month-sales',
      medianMonthSales: '/api/amazon-median-month-sales',
      medianIdentifierParam: 'asin',   // param name used by median endpoint
    },
    stockColumns: [
      { key: 'fbaStock', label: 'FBA Stock' },
      { key: 'awdStock', label: 'AWD Stock' },
    ],
    daysSuppliedKey: 'amazon',
    hasSeasonality: true,
    updateIdentifierParam: 'asin',
    updateQuantityParam: 'units',
    supportsFlags: true,
    // Недельные флаги есть только у amazon_week_sales; у остальных недельных
    // таблиц колонок флагов нет (range-эндпоинты отдают нули). После отказа от
    // ручной правки чисел недельный карандаш = только флаги, поэтому у других
    // маркетплейсов он в недельном виде скрыт.
    supportsWeeklyFlags: true,
  },

  walmart: {
    id: 'walmart',
    name: 'Walmart',
    identifierField: 'sku',
    productFilter: (product) => product.sku && product.sku.trim() !== '',
    endpoints: {
      salesRange: '/api/walmart-sales-range',
      updateSales: '/api/update-walmart-sales',
      uploadSales: '/api/upload-walmart-sales',
      uploadStock: null,
      stock: '/api/walmart-stock',
      awd: null,
      brands: '/api/yoy-brands',
      niches: '/api/yoy-niches',
      // Monthly
      monthSalesRange: '/api/walmart-month-sales-range',
      updateMonthSales: '/api/update-walmart-month-sales',
      uploadMonthSales: '/api/upload-walmart-month-sales',
      medianMonthSales: '/api/walmart-median-month-sales',
      medianIdentifierParam: 'sku',
    },
    stockColumns: [{ key: 'wmStock', label: 'Walmart Stock' }],
    daysSuppliedKey: 'walmart',
    hasSeasonality: true,
    updateIdentifierParam: 'sku',
    updateQuantityParam: 'quantity',
    supportsFlags: true,
  },

  shopify: {
    id: 'shopify',
    name: 'Shopify',
    identifierField: 'sku',
    productFilter: (product) => product.sku && product.sku.trim() !== '',
    endpoints: {
      salesRange: '/api/shopify-sales-range',
      updateSales: '/api/update-shopify-sales',
      uploadSales: '/api/shopify-sales-upload',
      uploadStock: null,
      stock: null,
      awd: null,
      brands: '/api/yoy-brands',
      niches: '/api/yoy-niches',
      // Monthly
      monthSalesRange: '/api/shopify-month-sales-range',
      updateMonthSales: '/api/update-shopify-month-sales',
      uploadMonthSales: '/api/shopify-month-sales-upload',
      medianMonthSales: '/api/shopify-median-month-sales',
      medianIdentifierParam: 'sku',
    },
    stockColumns: [],
    daysSuppliedKey: null,
    hasSeasonality: true,
    updateIdentifierParam: 'sku',
    updateQuantityParam: 'quantity',
    supportsFlags: true,
  },

  etsy: {
    id: 'etsy',
    name: 'Etsy',
    identifierField: 'sku',
    productFilter: (product) => product.sku && product.sku.trim() !== '',
    endpoints: {
      salesRange: '/api/etsy-sales-range',
      updateSales: '/api/update-etsy-sales',
      uploadSales: '/api/upload-etsy-sales',
      uploadStock: null,
      stock: null,
      awd: null,
      brands: '/api/yoy-brands',
      niches: '/api/yoy-niches',
      // Monthly
      monthSalesRange: '/api/etsy-month-sales-range',
      updateMonthSales: '/api/update-etsy-month-sales',
      uploadMonthSales: '/api/upload-etsy-month-sales',
      medianMonthSales: '/api/etsy-median-month-sales',
      medianIdentifierParam: 'sku',
    },
    stockColumns: [],
    daysSuppliedKey: null,
    hasSeasonality: true,
    updateIdentifierParam: 'item_id',
    updateMonthIdentifierParam: 'sku',
    updateQuantityParam: 'quantity',
    supportsFlags: true,
  },
};